import "./page-insurance.scss";
import "../../js/core";
import "../../components/site-elements/sliders/section-slider-partners/section-slider-partners";

import "../../components/site-elements/table/table-vh/table-vh";

$(function () {
    import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(()=>{
        import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(()=>{

            $('.owl-carousel').each(function(index) {
                $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls'></div>");
            });
        });
    });
});